import {FC} from 'react';
import {BlackFlatTooltip, DesignersTooltipItem} from './styles';
import {Avatar, Tooltip, FInter, FlexBox, ExternalLink} from '@brg/ui';
import {IDesignerLight} from '../../common';
import {CreateLinkTo} from "../../constants/linkTo";
import {Link} from '../link';

interface Theming {
  color: string
}
export interface ProjectDesignersTooltipProps {
    items: IDesignerLight[];
    visible?: boolean;
    toggleVisible?: () => void;
    theming?: Theming;
    containerRef?: any
}

export const ProjectDesignersTooltip: FC<ProjectDesignersTooltipProps & any/*TooltipProps*/> = (props) => {

    const {
        items,
        containerRef
    } = props;

    //todo придумать другой способ для ssr
    const domain = window.location.origin;

   return (<Tooltip {...props}>
    <BlackFlatTooltip ref={containerRef} hidden={items.length === 0}>
      <FlexBox direction="column" directionMobile="column" width="100%" wrapMobile={"wrap"} onClick={(ev) => ev.stopPropagation()}>
        {items.map((value: any) => {
          const isBigFullname = (value.name.length + value.surName.length) > 35
          
          return (<ExternalLink key={value.identifier} to={CreateLinkTo.designerNew(value)} external target="_self">
            <DesignersTooltipItem className="item">
              <FlexBox height="100%" align="center" width="100%">
                <FlexBox width={32} height={32} style={{ borderRadius: '3px' }}>
                  <Avatar {...value} fs={11} />
                </FlexBox>
                <FInter.SmallTextFlex className={'item-name'} offsetLeft={12} offsetRight={16} style={{ fontSize: isBigFullname ? '11px' : '13px', lineHeight: '16px' }}>
                  {value.name} {value.surName}
                </FInter.SmallTextFlex>
              </FlexBox>
            </DesignersTooltipItem>
          </ExternalLink>)
        })}
      </FlexBox>
    </BlackFlatTooltip>
  </Tooltip>)
};
import {FC} from 'react';
import {BlackFlatTooltip, DesignersTooltipItem} from './styles';
import {Avatar, Tooltip, FInter, FlexBox, ExternalLink} from '@brg/ui';
import {IDesignerLight} from '../../common';
import {CreateLinkTo} from "../../constants/linkTo";
import {Link} from '../link';

interface Theming {
  color: string
}
export interface ProjectDesignersTooltipProps {
    items: IDesignerLight[];
    visible?: boolean;
    toggleVisible?: () => void;
    theming?: Theming;
    containerRef?: any
}

export const ProjectDesignersTooltip: FC<ProjectDesignersTooltipProps & any/*TooltipProps*/> = (props) => {

    const {
        items,
        containerRef
    } = props;

    //todo придумать другой способ для ssr
    const domain = window.location.origin;

   return (<Tooltip {...props}>
    <BlackFlatTooltip ref={containerRef} hidden={items.length === 0}>
      <FlexBox direction="column" directionMobile="column" width="100%" wrapMobile={"wrap"} onClick={(ev) => ev.stopPropagation()}>
        {items.map((value: any) => {
          const isBigFullname = (value.name.length + value.surName.length) > 35
          
          return (<ExternalLink key={value.identifier} to={CreateLinkTo.designerNew(value)} external target="_self">
            <DesignersTooltipItem className="item">
              <FlexBox height="100%" align="center" width="100%">
                <FlexBox width={32} height={32} style={{ borderRadius: '3px' }}>
                  <Avatar {...value} fs={11} />
                </FlexBox>
                <FInter.SmallTextFlex className={'item-name'} offsetLeft={12} offsetRight={16} style={{ fontSize: isBigFullname ? '11px' : '13px', lineHeight: '16px' }}>
                  {value.name} {value.surName}
                </FInter.SmallTextFlex>
              </FlexBox>
            </DesignersTooltipItem>
          </ExternalLink>)
        })}
      </FlexBox>
    </BlackFlatTooltip>
  </Tooltip>)
};
